import React, { useEffect } from 'react';
import { useStore } from '../store/store';
import AppLogo from '../assets/logo.svg'
import Cancel from '../assets/cancel.svg';
import { appRoutes } from '../utils/app_routes';
import ShoppingBagIcon from '../assets/shopping_bag.svg'
import { Link, useLocation } from 'react-router-dom';

const SideBar = () => {
    const { state: { sidebar }, dispatch } = useStore()
    const { pathname } = useLocation();

    useEffect(() => {
        if (sidebar) {
            dispatch({ type: "TOGGLE_SIDEBAR", payload: sidebar })
        }
    }, [pathname])

    return (
        <div className={`h-dvh fixed top-0 left-0 w-full bg-white transform transition-transform duration-300 ${sidebar ? 'translate-x-0' : 'translate-x-full'} md:translate-x-full`}>
            <div className='h-20 shadow-md flex justify-between items-center ps-5'>
                <Link to={appRoutes.home}>
                    <img src={AppLogo} alt="App Logo" className='h-10' />
                </Link>
                <button className='flex md:hidden w-10' onClick={() => dispatch({ type: "TOGGLE_SIDEBAR", payload: sidebar })}>
                    <img src={Cancel} alt="Cancel_icon" className='h-5 ' />
                </button>
            </div>
            <div className='h-[calc(100dvh-80px)] w-full flex flex-col justify-between items-start p-5'>
                <div className='flex flex-col text-start w-full gap-3 '>
                    <Link to={appRoutes.shop}
                        className={`${pathname === appRoutes.shop ? "border-b border-primary !text-primary" : "border-none"} py-1 text-[18px] text-secondary font-[500] leading-[normal]`}>
                        Shop
                    </Link>
                    <Link to={appRoutes.blog}
                        className={`${pathname === appRoutes.blog ? "border-b border-primary !text-primary" : "border-none"} py-1 text-[18px] text-secondary font-[500] leading-[normal]`}>
                        Blog
                    </Link>
                    <Link to={appRoutes.about}
                        className={`${pathname === appRoutes.about ? "border-b border-primary !text-primary" : "border-none"} py-1 text-[18px] text-secondary font-[500] leading-[normal]`}>
                        About
                    </Link>
                    <Link to={appRoutes.contact}
                        className={`${pathname === appRoutes.contact ? "border-b border-primary !text-primary" : "border-none"} py-1 text-[18px] text-secondary font-[500] leading-[normal]`}>
                        Contact
                    </Link>
                </div>
                <div className='w-full'>
                    <button className="btn-primary !w-full flex gap-2 justify-center items-center">
                        <p>Bag</p>
                        <img src={ShoppingBagIcon} alt="Bag" className="h-5 w-5" />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SideBar;
